import { AvatarEntity } from "@cryptors/api-client";
import { Box } from "@mui/material";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";

import UploadButton from "@/components/forms/UploadButton";
import { upload } from "@/utils/upload";

interface AvatarFormValues {
  image: { url: string };
}

export const AvatarCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    refineCore: { formLoading, onFinish },
    control,
    formState: { isValid, isDirty },
    setError,
    handleSubmit,
  } = useForm<AvatarEntity, HttpError, AvatarFormValues>();

  const onFinishHandler = (data: AvatarFormValues) => {
    onFinish({
      image: { url: data.image.url },
    });
  };

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{
        onClick: handleSubmit(onFinishHandler),
        disabled: !isDirty || !isValid,
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Controller
          control={control}
          name="image.url"
          defaultValue=""
          rules={{ required: "Ce champ est requis" }}
          render={({ field, fieldState }) => (
            <UploadButton
              inputSrc={field.value}
              onError={() =>
                setError("image.url", {
                  message: "L'upload a échoué. Veuillez réessayer",
                })
              }
              onChange={async (event) => {
                const url = await upload(event, "avatars");
                field.onChange(url);
              }}
              errorMessage={fieldState.error?.message}
            />
          )}
        />
      </Box>
    </Create>
  );
};
